import React, {useState} from 'react';
import FeedbackService from '../services/feedbackService';

export const FeedbackContext = React.createContext();

const FeedbackContextProvider = ({ children }) => {
  const [pending, setPending] = useState(false);
  const [addFeedbackPending, setAddFeedbackPending] = useState(false);
  const [error, setError] = useState(false);
  const [feedback, setFeedback] = useState([]);

  const getFeedback = async () => {
    setError(false);
    setPending(true);
    const responseObj = await FeedbackService.getFeedback();

    if (responseObj.type === 'Error') {
      setError(true);
    } else {
      setFeedback(responseObj._embedded.contacts);
    }

    setPending(false);

    return responseObj;
  };

  const addFeedback = async formValues => {
    setError(false);
    setAddFeedbackPending(true);

    let payload = {...formValues};

    const response = await FeedbackService.addFeedback(payload);

    if (response !== 200) {
      setError(true);
      setAddFeedbackPending(false);
      return response;
    }

    setAddFeedbackPending(false);
    return response;
  };

  return (
    <FeedbackContext.Provider
      value={{
        pending,
        addFeedbackPending,
        error,
        feedback,
        getFeedback,
        addFeedback
      }}
    >
      {children}
    </FeedbackContext.Provider>
  );
};

export default FeedbackContextProvider;
